import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PermissionNoticeCard from '../components/PermissionNoticeCard';

const RoleRoute = ({ allowedRoles = [], requiredPermissions = [], requireAllPermissions = false }) => {
  const { isAuthenticated, loading, hasAnyRole, hasAnyPermission, hasAllPermissions, defaultHomeRoute } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-2">
          <div className="w-9 h-9 border-4 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#c44569', borderTopColor: 'transparent' }} />
          <p className="text-sm text-slate-500">Checking access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasAnyRole(allowedRoles)) return <Navigate to={defaultHomeRoute || '/dashboard'} replace />;
  if (requiredPermissions.length > 0) {
    const isAllowed = requireAllPermissions
      ? hasAllPermissions(requiredPermissions)
      : hasAnyPermission(requiredPermissions);
    if (!isAllowed) {
      // Render inline screen — never redirect here, redirecting to defaultHomeRoute
      // causes an infinite loop when the defaultHomeRoute itself requires the same permission.
      return <PermissionRequiredScreen />;
    }
  }

  return <Outlet />;
};

function PermissionRequiredScreen() {
  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4 py-12">
      <PermissionNoticeCard />
    </div>
  );
}

export default RoleRoute;
